import React from "react";
import ChPerformanceSingleChart from "./ChPerformanceSingleChart";
import { CHART_TYPES } from "../../ChPerformanceReportHelperLib/chPerformanceDataHelper";
import styles from "./chPerformanceReport.module.css";

const CHARTS = [
    { type: CHART_TYPES.PICKUP, title: "Placement to Pick up Time (excluding scheduled orders)" },
    { type: CHART_TYPES.DELIVERY, title: "Placement to Delivery Time (excluding scheduled orders)" },
    { type: CHART_TYPES.DRIVE, title: "Drive time (pickup to delivery)" },
    { type: CHART_TYPES.LATENESS, title: "On-time Deliveries" },
];

const ChPerformanceChartGrid = ({
    companyCharts,
    companySummaries,
    selectedCompanyIds,
    onBarClick,
    onTimeBufferMinutes = 0,
}) => {
    return (
        <div className={styles.chartGrid}>
            {CHARTS.map(({ type, title }) => (
                <div key={type} className={styles.chartCell}>
                    <ChPerformanceSingleChart
                        type={type}
                        title={title}
                        companyCharts={companyCharts}
                        companySummaries={companySummaries}
                        selectedCompanyIds={selectedCompanyIds}
                        onBarClick={onBarClick}
                        onTimeBufferMinutes={onTimeBufferMinutes}
                    />
                </div>
            ))}
        </div>
    );
};

export default ChPerformanceChartGrid;
